import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../shared/logger';

export const ExplainInDetailsLevel = {
    minimal: 0,
    minimalWithSkills: 1,
    full: 2,
    scoringComputationDetails: 3,
};

export const TalentScoreService = (Restangular, RouteService) => {
    const postTalentExplainScore = function (data) {
        const totalTalentPoolThresholds = RouteService.getSystemDefaults('searchEngineFilterTotalTalentPoolThresholds');
        const dataFilter = data.filter ? { ...data.filter } : {};

        if (dataFilter.selected) {
            dataFilter.selected = _.sortBy(dataFilter.selected, 'field');
        }

        const filter = {
            ...data,
            filter: {
                totalTalentPoolThresholds,
                ...dataFilter,
            },
        };
        return Restangular.all('talentScore')
            .all('explain')
            .post(filter)
            .catch(error => Logger.error(error));
    };

    const postTalentScore = function (request) {
        const totalTalentPoolThresholds = RouteService.getSystemDefaults('searchEngineFilterTotalTalentPoolThresholds');
        const filter = {
            totalTalentPoolThresholds,
            ...request,
        };
        return Restangular.all('talentScore')
            .post(filter)
            .catch(error => Logger.error(error));
    };

    const searchByPositionId = function (positionId, request) {
        const totalTalentPoolThresholds = RouteService.getSystemDefaults('searchEngineFilterTotalTalentPoolThresholds');
        const filter = {
            totalTalentPoolThresholds,
            ...request,
        };
        return Restangular
            .all(`talentScore/${positionId}`)
            .post(filter)
            .catch(error => Logger.error(error));
    };

    const getSearchExplainScore = function (positionId, body) {
        return Restangular.all(`talentScore/${positionId}`)
            .all('boostPriorities?expandedExplain=1')
            .post(body)
            .catch(error => Logger.error(error));
    };

    const searchFeedbackALikePriorities = function (body) {
        return Restangular.all('talentScore')
            .all('searchFeedbackALikePriorities')
            .post(body)
            .catch(error => Logger.error(error));
    };

    const searchDiversityALikePriorities = function (positionId, { filter, diversityIds }) {
        return Restangular.all(`talentScore/${positionId}`)
            .all('searchDiversityALikePriorities')
            .post({ filter, diversityIds })
            .catch(error => Logger.error(error));
    };

    const canSearchFeedbackALike = function (body) {
        return Restangular.all('talentScore')
            .all('canSearchFeedbackALike')
            .post(body)
            .catch(error => Logger.error(error));
    };

    return {
        postTalentExplainScore,
        postTalentScore,
        getSearchExplainScore,
        searchFeedbackALikePriorities,
        searchDiversityALikePriorities,
        canSearchFeedbackALike,
        searchByPositionId,
    };
};

angular
    .module('TALENYA-FE')
    .factory('TalentScoreService', TalentScoreService);
